import ReceiptIcon from '@material-ui/icons/Receipt';
import { IRouteItemContainer } from 'interfaces/route.interfaces';
import { RouteItemId } from 'common/enums/html.enums';
import { Routes } from 'constants/route.constants';
import { PoliciesPermissionSetItems as Permission } from 'common/constants/permissions';
import { ReactComponent as ResourceIcon } from 'img/icons/resource.svg';
import { ReactComponent as CalendarIcon } from 'img/icons/calendar.svg';
import { ReactComponent as MegaphoneIcon } from 'img/icons/sidebar/megaphon.svg';
import { ReactComponent as ShareIcon } from 'img/icons/share.svg';
import { ReactComponent as DaySheetsIcon } from 'img/icons/day-sheets.svg';
import { ReactComponent as KeyIcon } from 'img/icons/key.svg';
import { ReactComponent as PosSettingsIcon } from 'img/icons/sidebar/POS-Settings-icon.svg';
import { ReactComponent as PTCrmIcon } from 'img/icons/sidebar/running.svg';
import { ReactComponent as DocumentChartIcon } from 'img/icons/document-chart.svg';
import { ReactComponent as ServicesIcon } from 'img/icons/sidebar/mall.svg';
import { ReactComponent as TimeclockIcon } from 'img/icons/hourglass.svg';
import { ReactComponent as TaskIcon } from 'img/icons/task.svg';
import { ReactComponent as LeadIcon } from 'img/icons/lead.svg';
import { ReactComponent as ScriptIcon } from 'img/icons/script.svg';
import { ReactComponent as CampaignIcon } from 'img/icons/campaign.svg';
import { ReactComponent as MessageIcon } from 'img/icons/message.svg';
import { ReactComponent as EmailIcon } from 'img/icons/email.svg';
import { ReactComponent as CoinIcon } from 'img/icons/coin.svg';
import { ReactComponent as DocumentIcon } from 'img/icons/document.svg';
import { ReactComponent as DocumentLockIcon } from 'img/icons/document-lock.svg';
import { ReactComponent as BoxIcon } from 'img/icons/box.svg';
import { ReactComponent as BoxesIcon } from 'img/icons/boxes.svg';
import { ReactComponent as PhoneNotificationIcon } from 'img/icons/phone-notification.svg';
import { ReactComponent as PhoneAdIcon } from 'img/icons/phone-ad.svg';
import { ReactComponent as BillIcon } from 'img/icons/bill.svg';
import { ReactComponent as PercentBoxIcon } from 'img/icons/percent-box.svg';
import { ReactComponent as HashIcon } from 'img/icons/hash.svg';
import { ReactComponent as StoreIcon } from 'img/icons/store.svg';
import { ReactComponent as MonitorIcon } from 'img/icons/monitor.svg';
import { ReactComponent as CardIcon } from 'img/icons/card.svg';
import { ReactComponent as CreditCardPlusIcon } from 'img/icons/credit-card-plus.svg';
import { ReactComponent as UserSettingsIcon } from 'img/icons/user-settings.svg';
import { ReactComponent as LockClosedIcon } from 'img/icons/lock-closed.svg';
import { ReactComponent as BarChartIcon } from 'img/icons/bar-chart.svg';
import { ReactComponent as CloudIcon } from 'img/icons/cloud.svg';
import { ReactComponent as MoneyCheckIcon } from 'img/icons/money-check.svg';
import { ReactComponent as ServerIcon } from 'img/icons/server.svg';
import { ReactComponent as CashRegisterIcon } from 'img/icons/cash-register.svg';
import { ReactComponent as CartIcon } from 'img/icons/cart.svg';
import { ReactComponent as ClockFilledIcon } from 'img/icons/clock-filled.svg';
import { ReactComponent as ClockRotateIcon } from 'img/icons/clock-rotate.svg';
import { ReactComponent as TilesIcon } from 'img/icons/tiles.svg';
import { ReactComponent as CheckInIcon } from 'img/icons/sidebar/check-in.svg';
import { ReactComponent as ChildIcon } from 'img/icons/sidebar/Child.svg';
import { ReactComponent as ScheduledDocIcon } from 'img/icons/scheduled-document.svg';
import { ReactComponent as FinancialSummaryIcon } from 'img/icons/financial-summary.svg';
import { ReactComponent as SpambiIcon } from 'img/icons/sidebar/spambi.svg';
import { ReactComponent as UndoIcon } from 'img/icons/undo-solid.svg';
import bookingMessages from 'modules/booking/messages';
import communicationMessages from 'modules/communication/messages';
import commonMessages from 'common/messages/messages';
import crmMessages from 'modules/crm/messages/common';
import daySheetMessages from 'modules/day-sheet/messages/common';
import permissionMessages from 'modules/permissions/messages/messages';
import posSettingsMessages from 'modules/pos-settings/messages/messages';
import ptMessages from 'modules/personal-training-crm/messages/messages';
import reportMessages from 'modules/reports/messages/messages';
import serviceMessages from 'modules/services/messages/messages';
import timeclockMessages from 'modules/timeclock/messages';

export const bookingContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnBookingContainer,
  path: Routes.BOOKING,
  title: bookingMessages.booking,
  icon: CalendarIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnBookingCalendar,
      path: Routes.BOOKING_CALENDAR,
      title: bookingMessages.calendar,
      icon: CalendarIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.BOOKING_EVENTS_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnBookingResources,
      path: Routes.BOOKING_RESOURCES,
      title: bookingMessages.resources,
      icon: ResourceIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.BOOKING_RESOURCES_VIEW],
    },
  ],
};

export const communicationContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnCommunicationContainer,
  path: Routes.COMMUNICATION,
  title: commonMessages.communication,
  icon: MegaphoneIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCommunicationNotifications,
      path: Routes.COMMUNICATION_NOTIFICATIONS,
      title: communicationMessages.appPushNotifications,
      icon: PhoneNotificationIcon,
      iconViewBox: '0 0 34 38',
      permissions: [Permission.PUSH_NOTIFICATION_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCommunicationBanners,
      path: Routes.COMMUNICATION_BANNERS,
      title: communicationMessages.bannerADSForClubLife,
      icon: PhoneAdIcon,
      iconViewBox: '0 0 24 38',
      permissions: [Permission.BANNER_ADVERTISEMENT_VIEW],
    },
  ],
};

export const crmContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnCrmContainer,
  path: Routes.CRM,
  title: commonMessages.crm,
  icon: ShareIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCrmTasks,
      path: Routes.CRM_TASKS,
      title: crmMessages.tasks,
      icon: TaskIcon,
      iconViewBox: '0 0 18 24',
      permissions: [Permission.CRM_TASK_VIEW || Permission.CRM_TASK_VIEW_OWN],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCrmLeads,
      path: Routes.CRM_LEADS,
      title: crmMessages.leads,
      icon: LeadIcon,
      iconViewBox: '0 0 34 24',
      permissions: [Permission.CRM_LEAD_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCrmScripts,
      path: Routes.CRM_SCRIPTS,
      title: crmMessages.scripts,
      icon: ScriptIcon,
      iconViewBox: '0 0 29 24',
      permissions: [Permission.CRM_SCRIPT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCrmCampaigns,
      path: Routes.CRM_CAMPAIGNS,
      title: crmMessages.campaigns,
      icon: CampaignIcon,
      iconViewBox: '0 0 27 24',
      permissions: [Permission.CRM_CAMPAIGN_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCrmSmsTemplates,
      path: Routes.CRM_SMS_TEMPLATES,
      title: crmMessages.smsTemplates,
      icon: MessageIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.CRM_SMS_TEMPLATE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnCrmEmailTemplates,
      path: Routes.CRM_EMAIL_TEMPLATES,
      title: crmMessages.emailTemplates,
      icon: EmailIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.CRM_EMAIL_TEMPLATE_VIEW],
    },
  ],
};

export const ptCrmContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnPtCrmContainer,
  path: Routes.PT_CRM,
  title: commonMessages.ptcrm,
  icon: PTCrmIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPtCrmTasks,
      path: Routes.PT_CRM_TASKS,
      title: ptMessages.ptTasks,
      icon: TaskIcon,
      iconViewBox: '0 0 18 24',
      permissions: [Permission.PT_CRM_TASK_VIEW, Permission.PT_CRM_TASK_VIEW_OWN],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPtCrmLeads,
      path: Routes.PT_CRM_LEADS,
      title: ptMessages.ptLeads,
      icon: LeadIcon,
      iconViewBox: '0 0 34 24',
      permissions: [Permission.PT_CRM_LEAD_VIEW, Permission.PT_CRM_LEAD_VIEW_OWN],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPtCrmScripts,
      path: Routes.PT_CRM_SCRIPTS,
      title: ptMessages.ptScripts,
      icon: ScriptIcon,
      iconViewBox: '0 0 29 24',
      permissions: [Permission.PT_CRM_SCRIPT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPtCrmCampaigns,
      path: Routes.PT_CRM_CAMPAIGNS,
      title: ptMessages.ptCampaigns,
      icon: CampaignIcon,
      iconViewBox: '0 0 27 24',
      permissions: [Permission.PT_CRM_CAMPAIGN_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPtCrmSmsTemplates,
      path: Routes.PT_CRM_SMS_TEMPLATES,
      title: ptMessages.ptSmsTemplates,
      icon: MessageIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.PT_CRM_SMS_TEMPLATE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPtCrmEmailTemplates,
      path: Routes.PT_CRM_EMAIL_TEMPLATES,
      title: ptMessages.ptEmailTemplates,
      icon: EmailIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.PT_CRM_EMAIL_TEMPLATE_VIEW],
    },
  ],
};

export const daySheetContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnDaySheetContainer,
  path: Routes.DAY_SHEET,
  title: commonMessages.daySheet,
  icon: DaySheetsIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnDaySheets,
      path: Routes.DAY_SHEETS,
      title: daySheetMessages.daySheets,
      icon: CalendarIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.DAYSHEET_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnDaySheetCommissionRules,
      path: Routes.COMMISSION_RULES,
      title: daySheetMessages.commissionRules,
      icon: PercentBoxIcon,
      iconViewBox: '0 0 41 40',
      permissions: [Permission.COMMISSION_RULE_VIEW],
    },
  ],
};

export const permissionsContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnPermissionsContainer,
  path: Routes.PERMISSIONS,
  title: commonMessages.permissions,
  icon: KeyIcon,
  iconViewBox: '0 0 24 24',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnRoles,
      path: Routes.ROLES,
      title: permissionMessages.roles,
      icon: UserSettingsIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.SECURITY_ROLE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPolicies,
      path: Routes.POLICIES,
      title: permissionMessages.policies,
      icon: LockClosedIcon,
      iconViewBox: '0 0 16 16',
      permissions: [Permission.SECURITY_POLICY_VIEW],
    },
  ],
};

export const posContentContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnPosContentContainer,
  path: Routes.POS_CONTENT,
  title: commonMessages.posContent,
  icon: PosSettingsIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCReceiptTemplates,
      path: Routes.RECEIPTS,
      title: posSettingsMessages.recieptTemplates,
      icon: BillIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.RECEIPT_TEMPLATES_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCTaxRates,
      path: Routes.TAX_RATES,
      title: posSettingsMessages.taxRates,
      icon: PercentBoxIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.TAX_RATE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCRevenueCodes,
      path: Routes.REVENUE_CODES,
      title: posSettingsMessages.revenueCodes,
      icon: HashIcon,
      iconViewBox: '0 0 41 40',
      permissions: [Permission.REVENUE_CODE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCVendors,
      path: Routes.VENDORS,
      title: posSettingsMessages.vendors,
      icon: StoreIcon,
      iconViewBox: '0 0 41 40',
      permissions: [Permission.VENDOR_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCInventory,
      path: Routes.INVENTORY_ITEMS,
      title: posSettingsMessages.inventory,
      icon: ResourceIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.INVENTORY_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCRegisters,
      path: Routes.REGISTERS,
      title: posSettingsMessages.registers,
      icon: MonitorIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.REGISTER_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCPaymentMethodsDefault,
      path: Routes.DEFAULT_PAYMENT_METHODS,
      title: posSettingsMessages.defaultPaymentMethods,
      icon: CardIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.DEFAULT_PAYMENT_METHOD_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnPCPaymentMethodsCustom,
      path: Routes.CUSTOM_PAYMENT_METHODS,
      title: posSettingsMessages.customPaymentMethods,
      icon: CreditCardPlusIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.CUSTOM_PAYMENT_METHOD_VIEW],
    },
  ],
};

export const reportsContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnReportsContainer,
  path: Routes.REPORTS,
  title: commonMessages.reports,
  icon: DocumentChartIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'groupTitle',
      id: 'reportsGeneral',
      groupTitle: commonMessages.generalLabel,
      relatesTo: [
        RouteItemId.RouteItemBtnReportOverview,
        RouteItemId.RouteItemBtnReportExternalCollections,
      ],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportOverview,
      path: Routes.REPORT_OVERVIEW,
      title: reportMessages.overview,
      icon: BarChartIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.OVERVIEW_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportExternalCollections,
      path: Routes.REPORT_EXTERNAL_COLLECTIONS,
      title: reportMessages.externalCollections,
      icon: CloudIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.EXTERNAL_COLLECTIONS_REPORT_VIEW],
    },
    {
      type: 'groupTitle',
      id: 'reportsPOS',
      groupTitle: commonMessages.pos,
      relatesTo: [
        RouteItemId.RouteItemBtnReportSalesPos,
        RouteItemId.RouteItemBtnReportInvoiceHistory,
        RouteItemId.RouteItemBtnReportZOut,
        RouteItemId.RouteItemBtnReportSalesOverTime,
        RouteItemId.RouteItemBtnReportRegisterStatus,
        RouteItemId.RouteItemBtnReportRedemptions,
      ],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportSalesPos,
      path: Routes.REPORT_SALES_POS,
      title: reportMessages.salesPosReport,
      icon: CartIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.SALES_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportInvoiceHistory,
      path: Routes.REPORT_INVOICE_HISTORY,
      title: reportMessages.invoiceHistoryReport,
      icon: DocumentIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.INVOICE_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportZOut,
      path: Routes.REPORT_Z_OUT,
      title: reportMessages.zOut,
      icon: CashRegisterIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.Z_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportSalesOverTime,
      path: Routes.REPORT_SALES_OVER_TIME,
      title: reportMessages.salesOverTimeReport,
      icon: ClockFilledIcon,
      iconViewBox: '0 0 41 40',
      permissions: [Permission.OVER_TIME_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportRegisterStatus,
      path: Routes.REPORT_REGISTER_STATUS,
      title: reportMessages.registerStatusReport,
      icon: ServerIcon,
      iconViewBox: '0 0 41 40',
      permissions: [Permission.REGISTER_STATUS_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportRedemptions,
      path: Routes.REPORT_REDEMPTIONS,
      title: reportMessages.sessionRedemptionReport,
      icon: MoneyCheckIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.REDEMPTION_REPORT_VIEW],
    },
    {
      type: 'groupTitle',
      id: 'reportsCRM',
      groupTitle: commonMessages.crm,
      relatesTo: [
        RouteItemId.RouteItemBtnReportCRMDashboard,
        RouteItemId.RouteItemBtnReportCampaigns,
        RouteItemId.RouteItemBtnReportAppointments,
      ],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportCRMDashboard,
      path: Routes.REPORT_CRM_DASHBOARD,
      title: reportMessages.dashboard,
      icon: TilesIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.DASHBOARD_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportCampaigns,
      path: Routes.REPORT_CAMPAIGNS,
      title: reportMessages.campaignReport,
      icon: MegaphoneIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.CAMPAIGN_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportAppointments,
      path: Routes.REPORT_APPOINTMENTS,
      title: reportMessages.appointmentsReport,
      icon: CalendarIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.APPOINTMENT_REPORT_VIEW],
    },
    {
      type: 'groupTitle',
      id: 'reportsCheckIn',
      groupTitle: commonMessages.checkIn,
      relatesTo: [
        RouteItemId.RouteItemBtnReportCheckInHistory,
        RouteItemId.RouteItemBtnReportKidZoneCheckInHistory,
      ],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportCheckInHistory,
      path: Routes.REPORT_CHECK_IN_HISTORY,
      title: reportMessages.checkInHistory,
      icon: CheckInIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.CHECK_IN_HISTORY_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportKidZoneCheckInHistory,
      path: Routes.REPORT_KID_ZONE_CHECK_IN_HISTORY,
      title: reportMessages.kidZoneCheckInHistory,
      icon: ChildIcon,
      iconViewBox: '0 0 20 20',
      permissions: [Permission.KID_ZONE_CHECK_IN_HISTORY_REPORT_VIEW],
    },
    {
      type: 'groupTitle',
      id: 'reportsBilling',
      groupTitle: commonMessages.billingLabel,
      relatesTo: [
        RouteItemId.RouteItemBtnReportScheduledBillings,
        RouteItemId.RouteItemBtnReportPaymentTransactions,
        RouteItemId.RouteItemBtnReportChargePaymentAnalysis,
        RouteItemId.RouteItemBtnReportFinancialSummary,
        RouteItemId.RouteItemBtnReportDepositStatement,
      ],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportScheduledBillings,
      path: Routes.REPORT_SCHEDULED_BILLINGS,
      title: reportMessages.scheduledBillings,
      icon: ScheduledDocIcon,
      iconViewBox: '0 0 40 40',
      permissions: [Permission.SCHEDULED_BILLINGS_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportPaymentTransactions,
      path: Routes.REPORT_PAYMENT_TRANSACTIONS,
      title: reportMessages.paymentTransactionsReport,
      icon: ClockRotateIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.TRANSACTION_REPORT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportChargePaymentAnalysis,
      path: Routes.REPORT_CHARGE_PAYMENT_ANALYSIS,
      title: reportMessages.chargePaymentAnalysis,
      icon: DocumentChartIcon,
      iconViewBox: '0 0 20 20',
      // TODO: Add permissions
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportFinancialSummary,
      path: Routes.REPORT_FINANCIAL_SUMMARY,
      title: reportMessages.financialSummary,
      icon: FinancialSummaryIcon,
      iconViewBox: '0 0 41 40',
      // TODO: Add permissions
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnReportDepositStatement,
      path: Routes.REPORT_DEPOSIT_STATEMENT,
      title: reportMessages.depositStatement,
      icon: BillIcon,
      iconViewBox: '0 0 40 40',
      // TODO: Add permissions
    },
  ],
};

export const servicesContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnServicesContainer,
  path: Routes.SERVICES_ROOT,
  title: commonMessages.services,
  icon: ServicesIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnServices,
      path: Routes.SERVICES,
      title: serviceMessages.services,
      icon: BoxIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.SERVICE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnFees,
      path: Routes.FEES,
      title: serviceMessages.feeDictionary,
      icon: ReceiptIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.FEE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnServicePackages,
      path: Routes.SERVICE_PACKAGES,
      title: serviceMessages.servicePackages,
      icon: BoxesIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.SERVICE_BUNDLE_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnServiceContracts,
      path: Routes.CONTRACT_DOC_TEMPLATES,
      title: serviceMessages.contractTemplates,
      icon: DocumentIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.CONTRACT_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnServiceWaivers,
      path: Routes.WAIVER_DOC_TEMPLATES,
      title: serviceMessages.waiverTemplates,
      icon: DocumentLockIcon,
      iconViewBox: '0 0 41 40',
      permissions: [Permission.WAIVER_VIEW],
    },
  ],
};

export const timeclockContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnTimeclockContainer,
  path: Routes.TIMECLOCK,
  title: commonMessages.timeclock,
  icon: TimeclockIcon,
  iconViewBox: '0 0 20 20',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnTimeclockLog,
      path: Routes.TIMECLOCK_LOG,
      title: commonMessages.timeclockLog,
      icon: TimeclockIcon,
      iconViewBox: '0 0 20 20',
      permissions: [
        Permission.TIME_CLOCK_IN,
        Permission.TIME_CLOCK_VIEW,
        Permission.TIME_CLOCK_VIEW_OWN,
      ],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnTimeclockPayrollReport,
      path: Routes.TIMECLOCK_PAYROLL_REPORT,
      title: timeclockMessages.payrollReportLabel,
      icon: CoinIcon,
      iconViewBox: '0 0 20 20',
      permissions: [
        Permission.TIME_CLOCK_PAYROLL_REPORT_VIEW,
        Permission.TIME_CLOCK_PAYROLL_REPORT_VIEW_OWN,
      ],
    },
  ],
};

export const clientAdjustmentsContainer: IRouteItemContainer = {
  type: 'container',
  id: RouteItemId.RouteItemBtnClientAdjustmentsContainer,
  path: Routes.CLIENT_ADJUSTMENTS,
  title: commonMessages.clientAdjustments,
  icon: SpambiIcon,
  iconViewBox: '0 0 14 18',
  children: [
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnClientAdjustmentsClientAdjustmentsContainer,
      path: Routes.CLIENT_ADJUSTMENTS_LIST,
      title: commonMessages.clientAdjustmentsList,
      icon: SpambiIcon,
      iconViewBox: '0 0 14 18',
      permissions: [Permission.PEAK_CLIENT_ADJUSTMENTS_VIEW],
    },
    {
      type: 'navLink',
      id: RouteItemId.RouteItemBtnRecurringClientAdjustmentsContainer,
      path: Routes.RECURRING_CLIENT_ADJUSTMENTS,
      title: commonMessages.recurringAdjustments,
      icon: UndoIcon,
      iconViewBox: '0 0 24 24',
      permissions: [Permission.PEAK_RECURRING_CLIENT_ADJUSTMENTS_VIEW],
    },
  ],
};
